import React, { useEffect, useState } from 'react';
import List from './route_method/List'
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchWrapper } from '../../helpers';
import { Text } from '@chakra-ui/react';
function RoutingMethod() {
	const [listData, setListData] = useState([])
	const [channelList, setchannelList] = useState([])
	const { state } = useLocation();
	const { id: paramId } = useParams();
	const id = state?.id || paramId;

	useEffect(() => {
		loadList();
		loadChannelList()
	}, [])

	const loadChannelList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/channel/list`;
		const data = await fetchWrapper.get(url)
		const listValue = data.data.map(cRs => {
			return { id: cRs.id, name: cRs.name }
		})
		setchannelList(listValue);
	}


	const loadList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const data = await fetchWrapper.get(url)
		setListData(data.data);
	}


	return (
		<div>
			<Text fontSize="lg" color="gray.600" ml={4}>
				Routing Method
			</Text>
			<div style={{ display: "flex" }}>
				<div className="setting_menu_section" style={{ marginLeft: "1rem" }}>
					<div className="menu_section">
						<ul>
							{/* <li className={id === 0 ? "active" : ""}>
								<a href={`/settings/routing-method/0`}  >
									<p>Default</p>
								</a>
							</li> */}
							{listData.map(item => {
								return (
									<li className={+id === item.id ? "active" : ""} key={item?.id}>
										
										<Link to={`/settings/routing-method/${item.id}`}  >
											<p>{item.business_name}</p>
										</Link>
									</li>
								)
							})}
						</ul>
					</div>
				</div>
				<div className="setting_detail_section">
					<List customer_id={id} channelData={channelList} />
				</div>
			</div>
		</div>
	);
}

export default RoutingMethod;